import { ChangeDetectionStrategy, Component } from '@angular/core';

import { FormManagerService } from '@sim/form';
import { BaseFiltersComponent, FilterFieldsOptions } from '@ui/ui.module';

import { Collection, CollectionFilter, CollectionFilterMeta } from '../../models/collection';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-collection-filters',
  styleUrls: ['./collection-filters.component.scss'],
  templateUrl: './collection-filters.component.html',
})
export class CollectionFiltersComponent extends BaseFiltersComponent<Collection, FilterFieldsOptions<CollectionFilter>> {

  constructor(
    protected readonly formManager: FormManagerService,
  ) {
    super(formManager, CollectionFilterMeta);
  }

}
